import React from 'react'
import './BlackberryNavCategory.scss'

const BlackberryNavCategory = () => {

    return (
        <div className="bb-nav-category">
            <div className="bb-nav-category-container">
                <ul className="bb-nav-category-list">
                    <li><a href="#">Party Wear</a></li>
                    <li><a href="#">Casual Wear</a></li>
                    <li><a href="#">Indo Western</a></li>
                    <li><a href="#">Festive Wear</a></li>
                    <li><a href="#">Wedding Wear</a></li>
                    <li><a href="#">Lehengas</a></li>
                </ul>
            </div>
        </div>
    )
}

export default BlackberryNavCategory;